/** @format */

import actions from './actions';

/**
 * External dependencies
 */
import { addQueryArgs } from '@wordpress/url';
import { pickBy, identity, reduce } from 'lodash';

/**
 * Helper function that transforms array of products returned from API
 * to a more convenient Object keyed by products ids.
 *
 * @param {array} products
 */
function transformProductsListToObject( products ) {
	return reduce( products, function( obj, product ) {
		const id = product.id;
		delete product.id;
		product.durationUnit = product.duration_unit;
		delete product.duration_unit;
		obj[ id ] = product;
		return obj;
	},
	{}
	);
}

export default {
	* getProducts( query ) {
		query = query || {};

		const {
			productIds = '',
		} = query;

		const queryArgs = {
			include: productIds,
			per_page: -1,
			_locale: 'user',
		};

		const path = addQueryArgs(
			'/wc-bookings/v1/products',
			pickBy( queryArgs, identity )
		);

		try {
			const products = yield actions.fetchProductsFromAPI( { path: path } );
			const productsObj = transformProductsListToObject( products );
			return actions.setProducts( productsObj, products.length, query );
		} catch ( error ) {
			return actions.setProductsError( query );
		}
	},
};
